<ng-container *ngIf="multipleImage && !isVideo ">
  <div [ngClass]="hasImage ? 'image-wrapper' : 'noimage-wrapper'" [class.padding-top]="isRedmad"
       (clickOutside)="closeaction()">
    <input type="file" accept="image/*" #galleryimageuploadbutton
           (change)="fileChangeEvent($event)" hidden>
    <input type="file" accept="image/*" id="picture" capture #cameraimageuploadbutton
           (change)="fileChangeEvent($event)" hidden>
    <div class="img-box" *ngIf="!hasImage && !imageUploaded">
      <div class="image-container">
        <img *ngIf="!isSpinningWheel" class="dummy-img" src="/assets/image/scratch-card-dimension.png">
        <img *ngIf="isSpinningWheel" class="dummy-img" src="/assets/icon/image_picker_2.svg">

        <div *ngIf="isSpinningWheel" class="resolution-text">
          <div *ngIf="isBackgroundImage">
            1174 x 2000 px
          </div>
          <div *ngIf="!isBackgroundImage">
            2048 x 2048 px
          </div>
        </div>

      </div>
    </div>


    <div class="multiple-image" *ngIf="hasImage || imageUploaded">
      <div *ngIf="!isBackgroundImage" class="info">
        <p> {{activeSliderImageIndex + 1}} / {{imgSliderArray.length}} </p>
      </div>
      <swiper-container
        *ngIf="!isBackgroundImage"
        #swiper
        events-prefix="false"
        (init)="onswiperStart($event.detail[0])"
        (slidechange)="onSlideChange($event.detail[0])"
      >
        <swiper-slide *ngFor="let img of imgSliderArray">
          <img
            src="{{img.url}}"
            (load)="onImageLoaded()"/>
        </swiper-slide>
      </swiper-container>

      <div class="available-image" *ngIf="isBackgroundImage ">
        <img [src]="backgroundImageUrl" (load)="onImageLoaded()">
      </div>


      <div *ngIf="hasImage && !challengeStarted" class="jatak-buttons">

        <!--        edit button-->

        <button
          type="button"
          class="image-add-btn"
          (click)="toggleOptions()"
          [class.disabled]="isGif || disabled "
          *ngIf="imgSliderArray.length !== 5"
        >
          <div>
            <span *ngIf="isProcessing" class="loader"></span>
            <span *ngIf="!isProcessing">{{'_add_image_' | translate}}</span>
          </div>
          <ion-icon name="chevron-down-outline"></ion-icon>
        </button>

        <button
          type="button"
          class="image-add-btn"
          (click)="toggleOptions()"
          *ngIf="imgSliderArray.length === 5"
        >
          <div>
            <span *ngIf="isProcessing" class="loader"></span>
            <span *ngIf="!isProcessing">{{'_edit_image_' | translate}}</span>
          </div>
          <ion-icon name="chevron-down-outline"></ion-icon>

        </button>
        <ion-button
          [class.disabled]="disabled "
          (click)="onImageDelete()"
          class="image-delete-btn"
          expand="block"
        >
          <ion-icon class="custom-icon-size" name="trash"></ion-icon>
        </ion-button>
      </div>
    </div>

    <div (click)="onSlideNext()" [ngClass]="hasImage ? 'hasimagenext swiper-button-next1' : 'swiper-button-next1' "
         [class.disabled]="isNextButtonHidden">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
    <div (click)="onSlidePrevious()" [class.disabled]="isPrevButtonHidden"
         [ngClass]="hasImage ? 'hasimageprev swiper-button-prev1' : 'swiper-button-prev1' "
    >
      <ion-icon name="chevron-back-outline"></ion-icon>
    </div>


    <div>
      <div class="multiple-image">
        <button
          type="button"
          class="image-manipulate-btn-multiple"
          (click)="toggleOptions()"
          *ngIf="!imageUploaded && !hasImage"
        >
          <div>
            <span *ngIf="isProcessing" class="loader"></span>
            <span *ngIf="!isProcessing">{{'_upload_image_' | translate}}</span>
          </div>
          <ion-icon *ngIf="!showUploadOptions" name="chevron-down-outline"></ion-icon>
          <ion-icon *ngIf="showUploadOptions" name="chevron-up-outline"></ion-icon>

        </button>

        <div>
          <div *ngIf="showUploadOptions" class="upload-options">
            <div class="upload-type" (click)="cameraimageuploadbutton.click()">
              {{'_from_camera_' | translate}}
            </div>
            <div class="upload-type" (click)="galleryimageuploadbutton.click()">
              {{'_from_gallery_' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="image-editor" *ngIf="showEditor">
      <app-image-editor
        [mediaFile]="imageChangedEvent"
        [aspectRatio]="aspectRatio"
        (closeEditor)="closeEditor()"
        (imageProcessed)="imageProcessed($event)"
        (imageLoaded)="editorLoaded()"
        [customOptions]="editorOptions"
        [currentLanguage]="currentLanguage"
      ></app-image-editor>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="!multipleImage && !isBackgroundImage && !isVideo ">
  <div class="image-ctn">
    <input type="file" accept="image/*" #galleryimageuploadbutton
           (change)="fileChangeEvent($event)" hidden>
    <input type="file" accept="image/*" id="picture" capture #cameraimageuploadbutton
           (change)="fileChangeEvent($event)" hidden>
    <div class="initial-image">
      <div class="img-box" *ngIf="!hasImage && !imageUploaded">
        <div class="image-container">
          <img class="dummy-img" src="/assets/image/scratch-card-dimension.png">
          <div *ngIf="isSctrachCard && isBackgroundImage " class="dimension">
            1174 x 2000 px
          </div>
        </div>
      </div>
      <div class="available-image" *ngIf="hasImage" (click)="!editImage  || galleryimageuploadbutton.click()">
        <img [src]="imageUrl" (load)="onImageLoaded()">
      </div>
      <button
        type="button"
        class="single-image-btn"
        (click)="toggleOptions()"
        *ngIf="!imageUploaded && !hasImage"
      >
        <div>
          <span *ngIf="isProcessing" class="loader"></span>
          <span *ngIf="!isProcessing">{{'_upload_image_' | translate}}</span>
        </div>
        <ion-icon *ngIf="!showUploadOptions" name="chevron-down-outline"></ion-icon>
        <ion-icon *ngIf="showUploadOptions" name="chevron-up-outline"></ion-icon>

      </button>


      <button
        type="button"
        class="single-image-btn"
        (click)="toggleOptions()"
        *ngIf="imageUploaded || hasImage"
      >
        <div>
          <span *ngIf="isProcessing" class="loader"></span>
          <span *ngIf="!isProcessing">{{'_edit_image_' | translate}}</span>
        </div>
        <ion-icon *ngIf="!showUploadOptions" name="chevron-down-outline"></ion-icon>
        <ion-icon *ngIf="showUploadOptions" name="chevron-up-outline"></ion-icon>

      </button>

      <div>
        <div *ngIf="showUploadOptions" class="single-upload-options" [class.updatePosition]="isBackgroundImage"
             [class.imageuploaded]="hasImage">
          <div class="upload-type" (click)="cameraimageuploadbutton.click()">
            {{'_from_camera_' | translate}}
          </div>
          <div class="upload-type" (click)="galleryimageuploadbutton.click()">
            {{'_from_gallery_' | translate}}
          </div>
        </div>
      </div>


    </div>
    <div class="image-editor" *ngIf="showEditor">
      <app-image-editor
        [mediaFile]="imageChangedEvent"
        [aspectRatio]="aspectRatio"
        (closeEditor)="closeEditor()"
        (imageProcessed)="imageProcessed($event)"
        (imageLoaded)="editorLoaded()"
        [customOptions]="editorOptions"
        [currentLanguage]="currentLanguage"
      ></app-image-editor>
    </div>
  </div>

</ng-container>


<ng-container *ngIf="isSctrachCard && isBackgroundImage && !isVideo">
  <div style="padding-top: 0" class="image-ctn" (clickOutside)="closeaction()" >
    <input type="file" accept="image/*" #galleryimageuploadbutton
           (change)="fileChangeEvent($event)" hidden>
    <input type="file" accept="image/*" id="picture" capture #cameraimageuploadbutton
           (change)="fileChangeEvent($event)" hidden>
    <div class="background-image" >

      <swiper-container
        #swiper
        events-prefix="false"
        (init)="onBackgroundSlideChange($event.detail[0])"
        (slidechange)="onBackgroundSlideChange($event.detail[0])"
        space-between="50"
        slides-per-view="1"
        auto-height="true"
      >
        <swiper-slide *ngFor="let channel of channelsList">
          <div class="channel-name">
            {{ channel.name }}
          </div>
          <div class="background-image-box" *ngIf="!channel.hasImage && !channel.imageUploaded">
            <div class="image-container">
              <img class="dummy-img" src="/assets/image/scratch-card-dimension.png">
              <div *ngIf="isSctrachCard && isBackgroundImage " class="dimension">
                1174 x 2000 px
              </div>
            </div>
          </div>

          <div class="available-image" *ngIf="channel.hasImage">
            <img [src]="channel.images[0].url" (load)="onChannelImageLoad()">
          </div>
        </swiper-slide>
      </swiper-container>

      <div (click)="onSlideNext()" class="swiper-button-next1">
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </div>
      <div (click)="onSlidePrevious()" class="swiper-button-prev1">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </div>

      <div class="slide-count">{{ activeBackgroundImageSliderIndex + 1 }} / 4</div>


      <button
        type="button"
        class="single-image-btn"
        (click)="toggleOptions()"
        [class.disabled]="disabled"
        *ngIf="!imageUploaded && !hasImage"
      >
        <div>
          <span *ngIf="isProcessing" class="loader"></span>
          <span *ngIf="!isProcessing">{{'_upload_image_' | translate}}</span>
        </div>
        <ion-icon *ngIf="!showUploadOptions" name="chevron-down-outline"></ion-icon>
        <ion-icon *ngIf="showUploadOptions" name="chevron-up-outline"></ion-icon>

      </button>


      <button
        type="button"
        class="single-image-btn"
        (click)="toggleOptions()"
        [class.disabled]="disabled "
        *ngIf="imageUploaded || hasImage"
      >
        <div>
          <span *ngIf="isProcessing" class="loader"></span>
          <span *ngIf="!isProcessing">{{'_edit_image_' | translate}}</span>
        </div>
        <ion-icon *ngIf="!showUploadOptions" name="chevron-down-outline"></ion-icon>
        <ion-icon *ngIf="showUploadOptions" name="chevron-up-outline"></ion-icon>

      </button>


      <div *ngIf="showUploadOptions" class="background-image-upload" [class.updatePosition]="isBackgroundImage"
           [class.imageuploaded]="hasImage" >
        <div class="upload-type" (click)="cameraimageuploadbutton.click()">
          {{'_from_camera_' | translate}}
        </div>
        <div class="upload-type" (click)="galleryimageuploadbutton.click()">
          {{'_from_gallery_' | translate}}
        </div>
      </div>

    </div>
    <div class="image-editor" *ngIf="showEditor">
      <app-image-editor
        [mediaFile]="imageChangedEvent"
        [aspectRatio]="aspectRatio"
        (closeEditor)="closeEditor()"
        (imageProcessed)="imageProcessed($event)"
        (imageLoaded)="editorLoaded()"
        [customOptions]="editorOptions"
        [currentLanguage]="currentLanguage"
      ></app-image-editor>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isVideo">
  <div [ngClass]="hasVideo ? 'image-wrapper' : 'noimage-wrapper'" [class.padding-top]="isRedmad">
    <input
      type="file"
      accept=".mp4,.mov,.avi,.wmv,.mkv"
      #galleryimageuploadbutton
      (change)="fileChangeEvent($event)" hidden>
    <input
      type="file"
      id="picture"
      capture
      accept=".mp4,.mov,.avi,.wmv,.mkv"
      #cameraimageuploadbutton
      (change)="fileChangeEvent($event)" hidden>
    <div class="img-box" *ngIf="!hasVideo">
      <div class="image-container">
        <img *ngIf="!isSpinningWheel" class="dummy-img" src="/assets/image/scratch-card-dimension.png">
        <img *ngIf="isSpinningWheel" class="dummy-img" src="/assets/icon/image_picker_2.svg">

        <div *ngIf="isSpinningWheel" class="resolution-text">
          <div *ngIf="isBackgroundImage">
            1174 x 2000 px
          </div>
          <div *ngIf="!isBackgroundImage">
            2048 x 2048 px
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="hasVideo" class="video-container">
      <div
        class="video-box"
      >
        <video
          id="video"
          controls
          disablePictureInPicture
          playsinline
          muted
          autoplay
          name="media"
          #video
        >
          <source src="{{videoUrl}}" type="video/mp4">
        </video>
      </div>
    </div>

    <button
      type="button"
      [class.disabled]="disabled "
      (click)="toggleVideoOptions()"
      class="video-upload-btn"
    >
      <div>
        <span *ngIf="isProcessing" class="loader"></span>
        <span *ngIf="!isProcessing">Video upload</span>
      </div>

      <ion-icon *ngIf="!showVideoUploadOptions" name="chevron-down-outline"></ion-icon>
      <ion-icon *ngIf="showVideoUploadOptions" name="chevron-up-outline"></ion-icon>

    </button>

    <div *ngIf="showVideoUploadOptions" class="single-video-upload-options"
         [class.imageuploaded]="hasVideo">
      <div class="upload-type" (click)="cameraimageuploadbutton.click()">
        {{'_from_camera_' | translate}}
      </div>
      <div class="upload-type" (click)="galleryimageuploadbutton.click()">
        {{'_from_gallery_' | translate}}
      </div>
    </div>

  </div>
</ng-container>
